/**
 *
 * Created by jadelus on 10/13/17.
 *
 */
import { dangerouslyUseFeatureFlags } from 'utils/featureFlags/selectors';

/* eslint-disable no-console */

export const LogLevelsEnum = Object.freeze({
  DEBUG: 0,
  LOG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
  FATAL: 5,
  OFF: 6,
});

export function storeLoggingLevel(loggingLevel) {
  localStorage.setItem('loggingLevel', loggingLevel);
}

export function retrieveLoggingLevel() {
  let loggingLevel = LogLevelsEnum.INFO; // default for prod
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////
///////////

  const featureFlags = dangerouslyUseFeatureFlags();
  const loggingLevelServer = featureFlags && featureFlags.get && featureFlags.get('loggingLevel'); // server override
  if (loggingLevelServer >= 0 && loggingLevelServer <= 6) {
    loggingLevel = loggingLevelServer;
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
///////////////////////////////////////////
///
///////////

  return loggingLevel;
}

const Logger = {
  loggingLevelOverride: undefined,
  debug(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.DEBUG) {
      const message = args && args.shift() || '';
      console.debug(`%c${this.name} DEBUG:  ${message}`, 'color: green;', ...args);
    }
  },
  log(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.LOG) {
      const message = args && args.shift() || '';
      console.log(`%c${this.name} LOG: ${message}`, 'color: navy;', ...args);
    }
  },
  info(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.INFO) {
      const message = args && args.shift() || '';
      console.info(`%c${this.name} INFO:  ${message}`, 'color: blue;', ...args);
    }
  },
  warn(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.WARN) {
      const message = args && args.shift() || '';
      console.warn(`%c${this.name} WARN:  ${message}`, 'color: crimson;', ...args);
    }
  },
  error(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.ERROR) {
      const message = args && args.shift() || '';
      console.error(`%c${this.name} ERROR:  ${message}`, 'color: red;', ...args);
    }
  },
  fatal(...args) {
    if (this.loggingLevel() <= LogLevelsEnum.FATAL) {
      const message = args && args.shift() || '';
      console.error(`%c${this.name} FATAL:  ${message}`, 'color: darkred;', ...args);
    }
  },
  loggingLevel() {
    return this.loggingLevelOverride !== undefined ? this.loggingLevelOverride : retrieveLoggingLevel();
  },
};

export function getLogger(name) {
  return ({ ...Logger, name: name || 'logger' });
}
